import { AthleteAuthorizeFlowProvider } from '@modules/invites/contexts/AthleteAuthorizeFlow';

export const AppInvitesProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <AthleteAuthorizeFlowProvider>{children}</AthleteAuthorizeFlowProvider>;
};
